module.exports = __webpack_public_path__ + "media/images/bg/logo-watermark-7331a54b7fcb6f9fd099e834ea9ea4b8.svg";